import {Attributes, Variant} from '@aboutyou/backbone/types/BapiProduct';
import {ProductSize} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_size.types';
import {TrackingVariant} from '@aboutyou/legacy-tracking-sdk';
import {
  getTrackingPrice,
  getTrackingPriceFromBapiPrice,
} from './getTrackingPrice';

const getSizeLabel = (
  attributes: Attributes | undefined,
  type = 'vendorSize',
): string => {
  const debugMessage = `*** size label not found ***`;
  if (attributes && attributes[type]) {
    const attribute = attributes[type];

    return (
      (attribute &&
        attribute.multiSelect === false &&
        attribute.values.label) ||
      debugMessage
    );
  }

  return debugMessage;
};

export const getTrackingVariant = (variant: Variant): TrackingVariant => {
  return {
    id: variant.id,
    supplierId: variant.stock.supplierId || -1,
    sizeLabel: getSizeLabel(variant.attributes),
    price: getTrackingPriceFromBapiPrice(variant.price),
  };
};

export const getTrackingSize = (
  size: ProductSize,
  sizeLabel: string,
): TrackingVariant => {
  return {
    id: size.id,
    supplierId: size.supplierId,
    sizeLabel,
    price: getTrackingPrice(size.price),
  };
};
